import classnames from 'classnames';
import React from 'react';
import { openExternalLink } from 'utils/openExternalLink';
import { isCordova } from 'utils/platform';

const CSS = require('./RoundedButton.module.scss');

interface AnchorButtonProps {
  children: any;
  size?: 'XS' | 'S' | 'M' | 'L';
  className?: string;
  inverted?: boolean;
  pink?: boolean;
  yellow?: boolean;
  sandstone?: boolean;
  jade?: boolean;
  danger?: boolean;
  onClick?: (event: any) => void;
  fullWidth?: boolean;
  invertedBorder?: boolean;
  outlined?: boolean;
  elevated?: boolean;
  href: string;
  edgeRounding?: 'slight' | 'medium' | 'full';
  [key: string]: any;
}

function AnchorButton({
  size = 'M',
  children,
  className,
  inverted,
  pink,
  yellow,
  sandstone,
  jade,
  danger,
  fullWidth,
  invertedBorder,
  outlined,
  elevated,
  href,
  onClick,
  edgeRounding = 'full',
  ...rest
}: AnchorButtonProps) {
  const classes = classnames(CSS.Button, CSS.Link, {
    [className]: className,
    [CSS.Inverted]: inverted,
    [CSS.InvertedBorder]: invertedBorder,
    [CSS.PinkButton]: pink,
    [CSS.YellowButton]: yellow,
    [CSS.SandstoneButton]: sandstone,
    [CSS.JadeButton]: jade,
    [CSS.DangerButton]: danger,
    [CSS.FullWidth]: fullWidth,
    [CSS.ExtraSmall]: size === 'XS',
    [CSS.Large]: size === 'L',
    [CSS.Small]: size === 'S',
    [CSS.EdgeRoundedSlight]: edgeRounding === 'slight',
    [CSS.EdgeRoundedMedium]: edgeRounding === 'medium',
    [CSS.OutlinedButton]: outlined,
    [CSS.ButtonElevated]: elevated,
  });

  const onLinkClick = (e) => {
    if (isCordova()) {
      e.preventDefault();
      void openExternalLink(href);
    }

    onClick && onClick(e);
  };

  return (
    <a
      href={href}
      className={classes}
      onClick={onLinkClick}
      rel="noopener noreferrer"
      {...rest}
    >
      <span className={CSS.LinkChildren}>{children}</span>
    </a>
  );
}

export default AnchorButton;
